import './FulfillmentButton.scss';

type Props = {
  className?: string;
  icon: JSX.Element;
  title: string;
  subText: string | JSX.Element;
  selected?: boolean;
  disabled?: boolean;
  type: string;
  onClick: () => void;
};

const FulfillmentButton = ({
  icon,
  title,
  subText,
  type,
  onClick,
  selected = false,
  disabled = false,
  className = '',
}: Props) => {
  return (
    <button
      className={`FulfillmentButton fill-secondary-static hmf-position-relative ${
        selected ? 'FulfillmentButton-selected' : ''
      }${disabled ? ' FulfillmentButton-disabled' : ''} hmf-flex-grow${
        className ? ` ${className}` : ''
      } hmf-display-flex hmf-flex-row hmf-px-xxs hmf-py-s FulfillmentMessaging-${type}`}
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
      }}
      onMouseDown={(e) => e.preventDefault()}
      aria-controls={`FulfillmentMessaging-${type}`}
      aria-describedby={`FulfillmentMessaging-${type}`}>
      <div className="FulfillmentButton-content hmf-display-flex hmf-flex-column hmf-align-items-flex-start">
        {icon}
        <p
          className={`hmf-body-bold-l hmf-m-0 hmf-my-xxxs ${
            disabled ? 'label-disabled' : 'label-base'
          }`}>
          {title}
        </p>
        <p
          className={`hmf-body-m hmf-m-0 ${
            disabled ? 'label-disabled' : 'label-secondary-subtle-static'
          }`}>
          {subText}
        </p>
      </div>
    </button>
  );
};

export default FulfillmentButton;
